
import { Link } from "react-router-dom";

export default function CreateSection() {
	return (
		<div className="bg-white rounded-[10px] p-[10px]">
			<div className="flex flex-row items-center">
				<div className="font-Vazir-700 text-[#000000] text-[16px]">
					آیا می‌خواهید سوال جدید بپرسید
				</div>
				<div className="spacer p-[5px]"></div>
				<Link to="/discussion_add/">
					<div className="p-[5px] flex items-center justify-center font-Vazir-700 font-semibold text-[14px] rounded-[8px] bg-cta text-white">
						سوال جدید
					</div>
				</Link>
			</div>
		</div>
	)
}
